import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/returns.scss";

function Returns() {
  const steps = [
    ["01", "Start your return", "Contact our team with your order number and the pieces you would like to return."],
    ["02", "Pack your pieces", "Use the original packaging where possible. Items must be unworn, unwashed and have all tags attached."],
    ["03", "Send it back", "Attach the prepaid label, then leave the parcel with the carrier shown on your return instructions."],
    ["04", "Receive your refund", "After inspection, your original payment method is credited within 5–10 business days."],
  ];

  return (
    <main className="info-page returns-page">
      <header className="info-hero"><p className="eyebrow">HELP</p><h1>Returns & exchanges</h1><p>You have {siteConfig.shipping.returnsWindow} days from delivery to make sure every piece feels right.</p></header>
      <section className="return-steps">{steps.map(([number, title, copy]) => <article key={number}><span>{number}</span><h2>{title}</h2><p>{copy}</p></article>)}</section>
      <section className="returns-note"><div><p className="eyebrow">GOOD TO KNOW</p><h2>Items should come back as they arrived.</h2></div><div><p>Worn, washed, altered or damaged pieces cannot be refunded. Shoes should be tried on a clean, soft surface and returned in their protective packaging.</p><p>For hygiene reasons, socks and final-sale pieces are not returnable unless faulty. An exchange is handled as a return followed by a new order, so your preferred piece reaches you sooner.</p></div></section>
      <section className="info-cta"><h2>Ready to make a return?</h2><p>Have your order number nearby and we will guide you from there.</p><Link className="button button--dark" to="/contact">Start a return</Link></section>
    </main>
  );
}

export default Returns;
